<template>
    <div>

        <el-row :gutter="20">
            <el-table :data="ruleList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
            >
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="activeRuleId" label="id" width="70"></el-table-column>
                <el-table-column prop="activeNo" label="活动" width="100">
                    <template slot-scope="scope">
                        <span>{{getActiveName(scope.row.activeNo)}}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="inviteQuantityMin" label="起始邀请数量" width="170"></el-table-column>
                <el-table-column prop="inviteQuantityMax" label="截止邀请数量" width="170"></el-table-column>
                <el-table-column prop="bindCode" label="绑定码" width="270"></el-table-column>
                <el-table-column label="操作" fixed="right" >
                    <template slot="header" slot-scope="scope">
                        操作
                        <el-button type="primary" size="mini" @click="addRule()" class="header-btn">新建</el-button>
                    </template>
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="deleteRule(scope.row)">删除</el-button>
                        <el-button type="primary" size="mini" @click="gotoConfigCoupon(scope.row)">配置优惠券</el-button>
                        <!--<el-button type="primary" size="mini" @click="gotoConfigDiscount(scope.row)">拼单折扣</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-dialog title="兑奖规则" :visible.sync="showDialog">
            <el-form :model="activeRule" label-width="120px">
                <el-form-item label="起始邀请数量" prop="inviteQuantityMin">
                    <el-input-number v-model="activeRule.inviteQuantityMin" :min="0" :max="100" :step="1"
                                     placeholder="0 "></el-input-number>
                </el-form-item>
                <el-form-item label="截止邀请数量" prop="inviteQuantityMax">
                    <el-input-number v-model="activeRule.inviteQuantityMax" :min="0" :max="100" :step="1"
                                     placeholder="0 "></el-input-number>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="saveActiveRule()" class="header-btn">
                        保 存
                    </el-button>
                </el-form-item>

            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        deleteActiveRuleApi,
        getActiveRuleListApi,
        deleteCouponConfigByBindCodeApi ,
        saveActiveRuleApi
    } from '../../api/api';
    export default {
        data() {
            return {
                activeRule: {
                    inviteQuantityMin: 0,
                    inviteQuantityMax: 0,
                    activeNo: '',
                },
                ruleList: [],
                showDialog: false,
                formInline: {
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                loading: true,
                activeName: '',
                rules: {
                    endTime: [
                        {required: true, message: '结束时间必填', trigger: 'blur'}
                    ],
                    startingPrice: [
                        {required: true, message: '开始时间必填', trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: '请输入活动名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ],
                    startingPrice: [
                        {required: true, message: '请输入拼单起步价', trigger: 'blur'}
                    ],
                    discount: [
                        {required: true, message: '请输入新人优惠金额', trigger: 'blur'}
                    ]
                }
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.activeRule.activeNo = this.$route.query.activeNo;
            this.activeName = this.$route.query.activeName;
            //初始化首页数据
            this.getActiveRuleList();
        },
        methods: {
            addRule(){
                this.showDialog = true;
            },
            deleteRule(row){
                this.$confirm('删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //删除继续
                    deleteActiveRuleApi({id: row.activeRuleId}).then((res) => {
                        console.log(res);
                        if (res.data.success) {
                            this.getActiveRuleList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                    deleteCouponConfigByBindCodeApi({bindCode:row.bindCode}).then((res) => {
                        if (res.data.status == 200) {

                        } else {
                            this.$message({
                                showClose: true,
                                message: '删除失败',
                                type: 'error'
                            });
                        }
                    });
                });
            },
            returnHistory(){
                window.history.back()
            },
            getActiveName(activeNo){
                return this.activeName;
            },
            saveActiveRule(){
                if(this.activeRule.inviteQuantityMax<this.activeRule.inviteQuantityMin){
                    this.$message({
                        message: '起始，请检查',
                        type: 'error'
                    });
                    return;
                }
                saveActiveRuleApi(this.activeRule).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.showDialog=false;
                        this.getActiveRuleList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getActiveRuleList(){
                //查询所有的活动列表
                this.loading = true;
                getActiveRuleListApi({activeNo:this.activeRule.activeNo}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.ruleList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            gotoConfigCoupon(row) {
                console.log(row.ACTIVE_NO)
                this.$router.push({path: '/coupon', query: {bindCode: row.bindCode, sourceName: this.activeName + ':活动兑奖',type: '兑奖后'}})
            }

        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/active/activeRule.vue